import React, { useCallback } from 'react';
import { PropTypes } from 'prop-types';
// logic
import { showBeamer } from 'analytics/beamer';
// styles
import styled, { css } from 'styled-components';
import { media } from 'utils/style';

// this button is to open beamer, only visible on mobile
// the icon is empty because we use the original beamer button
// icon position is set up in 'analytics/beamer/beamerStyles'
const AppBarNewsButton = ({ className }) => {
  const onClick = useCallback(() => {
    showBeamer();
  }, []);
  return (
    <button aria-label="News" className={className} onClick={onClick}></button>
  );
};

AppBarNewsButton.propTypes = {
  className: PropTypes.string,
};

const regularCSS = css`
  border: none;
  padding: 0;
  width: 36px;
  max-width: 36px;
  height: 71px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  display: none;
`;

const mobileCSS = css`
  background-color: var(--primary500);
  width: 72px;
  max-width: 72px;
  border-left: 1px solid var(--primary-200-opacity30);
  display: flex;
  &:hover {
    background-color: var(--primary500);
  }
`;

export default styled(AppBarNewsButton)`
  ${regularCSS}
  ${media.lessThan('small')`${mobileCSS}`}
`;
